export const NGUOIDUNG_ROLE_LIST_INITING             = 'NGUOIDUNG_ROLE_LIST_INITING'
export const NGUOIDUNG_ROLE_LIST_REQUESTING          = 'NGUOIDUNG_ROLE_LIST_REQUESTING'
export const NGUOIDUNG_ROLE_LIST_SUCCESS             = 'NGUOIDUNG_ROLE_LIST_SUCCESS'
export const NGUOIDUNG_ROLE_LIST_ERROR               = 'NGUOIDUNG_ROLE_LIST_ERROR'   

export const NGUOIDUNG_ROLE_DETAIL_INITING           = 'NGUOIDUNG_ROLE_DETAIL_INITING'
export const NGUOIDUNG_ROLE_DETAIL_REQUESTING        = 'NGUOIDUNG_ROLE_DETAIL_REQUESTING'
export const NGUOIDUNG_ROLE_DETAIL_SUCCESS           = 'NGUOIDUNG_ROLE_DETAIL_SUCCESS'
export const NGUOIDUNG_ROLE_DETAIL_ERROR             = 'NGUOIDUNG_ROLE_DETAIL_ERROR'   

export const NGUOIDUNG_ROLE_UPDATE_REQUESTING        = 'NGUOIDUNG_ROLE_UPDATE_REQUESTING'
export const NGUOIDUNG_ROLE_UPDATE_SUCCESS           = 'NGUOIDUNG_ROLE_UPDATE_SUCCESS'
export const NGUOIDUNG_ROLE_UPDATE_ERROR             = 'NGUOIDUNG_ROLE_UPDATE_ERROR'   

export const NGUOIDUNG_ROLE_DETAIL_API               = '/api/v1/role/nguoidung_role_list_by'  
export const NGUOIDUNG_ROLE_LIST_API                 = '/api/v1/role/roles_list_by_store'   
export const NGUOIDUNG_ROLE_UPDATE_API               = '/api/v1/role/nguoidung_role_update_by_ids'  


// WEBPACK FOOTER //
// ./src/views/NguoiDungRole/constants.js